import { CALL_ACCOUNT_SYSTEM_API } from '../../middleware/authHeaders'
import { ACCOUNT_SYSTEM_API_ROOT } from '../../config/api'

export const ACCOUNTS_GET_USERS_REQUEST = 'ACCOUNTS_GET_USERS_REQUEST'
export const ACCOUNTS_GET_USERS_SUCCESS = 'ACCOUNTS_GET_USERS_SUCCESS'
export const ACCOUNTS_GET_USERS_FAILURE = 'ACCOUNTS_GET_USERS_FAILURE'

export const getAccountsUsers =
  (page, pageSize = 10, email = '', name = '') =>
  dispatch => {
    let endpoint = `${ACCOUNT_SYSTEM_API_ROOT}/v2/users/?page=${page}&pageSize=${pageSize}`

    if (name) {
      endpoint += `&name=${encodeURIComponent(name)}`
    }
    if (email) {
      endpoint += `&email=${encodeURIComponent(email)}`
    }

    return dispatch({
      [CALL_ACCOUNT_SYSTEM_API]: {
        method: 'GET',
        endpoint,
        types: [ACCOUNTS_GET_USERS_REQUEST, ACCOUNTS_GET_USERS_SUCCESS, ACCOUNTS_GET_USERS_FAILURE],
      },
    })
  }

export const ACCOUNTS_GET_USER_DETAILS_REQUEST = 'ACCOUNTS_GET_USER_DETAILS_REQUEST'
export const ACCOUNTS_GET_USER_DETAILS_SUCCESS = 'ACCOUNTS_GET_USER_DETAILS_SUCCESS'
export const ACCOUNTS_GET_USER_DETAILS_FAILURE = 'ACCOUNTS_GET_USER_DETAILS_FAILURE'

export const getAccountsUserDetails = userId => dispatch =>
  dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'GET',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/users/${userId}?showblocks=true`,
      types: [
        ACCOUNTS_GET_USER_DETAILS_REQUEST,
        ACCOUNTS_GET_USER_DETAILS_SUCCESS,
        ACCOUNTS_GET_USER_DETAILS_FAILURE,
      ],
    },
  })

export const ACCOUNTS_BLOCK_USER_ACCOUNT_REQUEST = 'ACCOUNTS_BLOCK_USER_ACCOUNT_REQUEST'
export const ACCOUNTS_BLOCK_USER_ACCOUNT_SUCCESS = 'ACCOUNTS_BLOCK_USER_ACCOUNT_SUCCESS'
export const ACCOUNTS_BLOCK_USER_ACCOUNT_FAILURE = 'ACCOUNTS_BLOCK_USER_ACCOUNT_FAILURE'

export const patchBlockUserAccount = (userId, shouldBlock) => dispatch =>
  dispatch({
    [CALL_ACCOUNT_SYSTEM_API]: {
      method: 'PATCH',
      endpoint: `${ACCOUNT_SYSTEM_API_ROOT}/v2/users/${userId}/status`,
      body: JSON.stringify({ shouldBlockUser: shouldBlock }),
      types: [
        ACCOUNTS_BLOCK_USER_ACCOUNT_REQUEST,
        ACCOUNTS_BLOCK_USER_ACCOUNT_SUCCESS,
        ACCOUNTS_BLOCK_USER_ACCOUNT_FAILURE,
      ],
    },
  })

// SELECTORS
export const selectAccountsUserSlice = state => state.accounts.accountsUsers

export const selectAccountsUsers = state => selectAccountsUserSlice(state).userList

export const selectSelectedUser = state => selectAccountsUserSlice(state).selectedUser

// STATE
const ACCOUNTS_INITIAL_STATE = {
  userList: {},
  selectedUser: null,
}

const transformUserList = payload => {
  const userList = payload

  if (!userList.items[0]) {
    userList.items = []
  }

  return userList
}

// REDUCERS
const accountsUsers = (state = ACCOUNTS_INITIAL_STATE, { type, payload } = {}) =>
  ({
    [ACCOUNTS_GET_USERS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      userList: transformUserList(newPayload),
    }),
    [ACCOUNTS_GET_USER_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedUser: newPayload,
    }),
    [ACCOUNTS_BLOCK_USER_ACCOUNT_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedUser: { ...currentState.selectedUser, blocked: newPayload.blocked },
    }),
  }[type]?.(state, payload) || state)

export default accountsUsers
